import axios from "axios";
const BASE_URL="http://192.168.60.214:9797/"

export async function getDeviceList(payload) {
  try {
    const apiEndPoint = `${BASE_URL}api/deviceList`;

    const response = await axios.post(apiEndPoint, payload, {
     
    });

    return response?.data;
  } catch (error) {
    console.error("getDeviceList Error:", error);
    throw error;
  }
}

export const getCustomerTree = async () => {
  const { data } = await axios.post(`${BASE_URL}api/customerTree`, {
    customerId: "",
    queryCount: false,
    deviceBasicType: null,
  },

);
  return data;
};


export const getbaseInfo=async ()=>{
const response =await axios.post(`${BASE_URL}api/userBaseInfo`,{
  
});
return response.data;

}

export const getDevicesByCustomerId = async ({
  customerId,
  deviceIdOrName = "",
  pageIndex = 1,
  pageSize = 50,
}) => {
  const { data } = await axios.post(`${BASE_URL}api/devicePageByCustomerId`, {
    deviceIdOrName,
    labelIds: "",
    pageIndex,
    pageSize,
    deviceBasicType: "video",
    isSupportsTimezone: "",
    deviceTypes: "",
    personal: "",
    licenseStatus: null,
    subCustomer: false,
    deviceStatus: "1",
    customerId,
  },


);
  return data;
};

export async function getDeviceExpandInfo(deviceId) {
  try {
    const response = await axios.post(
     `${BASE_URL}api/channel-info`,
      {
        deviceId,
      },
     
    );

    return response?.data;
  } catch (error) {
    console.error("getDeviceExpandInfo Error:", error);
    throw error;
  }
}

export async function getLiveVideoStream({
  deviceId,
  channelId,
  bitstreamType = 1,
  videoChannel = "india-1",
}) {
  try {
    const response = await axios.post(
      `${BASE_URL}api/videoLive`,
      {
        deviceId,
        channelId: String(channelId),
        bitstreamType,
        videoChannel,
      },
      
    );

    return response.data;
  } catch (error) {
    console.error("getLiveVideoStream Error:", error);
    throw error;
  }
}

export async function getAlarmPage(payload) {
  try {
    const response = await axios.post(`${BASE_URL}api/alarmInfoPage`, payload, {
     
    });

    return response?.data;
  } catch (error) {
    console.error("getAlarmPage Error:", error);
    throw error;
  }
}

export async function getAlarmFiles(payload) {
  try {
    const response = await axios.post(`${BASE_URL}api/alarmFiles`, payload, {
     
    });

    return response?.data;
  } catch (error) {
    console.error("getAlarmFiles Error:", error);
    throw error;
  }
}

export async function getAlarmDetail(alarmId) {
  try {
    const response = await axios.post(
      `${BASE_URL}api/deviceAlarmData`,
      { alarmId },
      
    );
    return response?.data;
  } catch (error) {
    console.error("getAlarmDetail Error:", error);
    throw error;
  }
}

export async function getAlarmPoi({ lat, lon }) {
  try {
    const response = await axios.post(
     `${BASE_URL}api/poi`,
      { lat, lon },
      
    );
    return response?.data;
  } catch (error) {
    console.error("getPoiAddress Error:", error);
    throw error;
  }
}

export async function getAlarmGpsByDeviceId({ deviceId, start, end }) {
  try {
    const response = await axios.post(
      `${BASE_URL}api/gpsByDeviceId`,
      { deviceId, start, end },
      
    );
    return response?.data;
  } catch (error) {
    console.error("getGpsTrajectory Error:", error);
    throw error;
  }
}


export const getAlarmTypeList = async () => {
  const response = await axios.post(
    `${BASE_URL}api/languageFormatList`,
    {
      languageCode: "en_US",
      formatType: "alarm_type",
    },
   
  );

  return response.data;
};


async function fetchMonitorAbbrev() {
  const response = await axios.post(
    `${BASE_URL}api/deviceMonitorAbbrev`,
    {
      customerId: "1988567584586657792",
      customerName: "Watsoo Express Pvt Ltd",
      deviceBasicType: "gps",
      deviceIdOrName: null,
      labelIds: null,
      deviceTypes: null,
      pageIndex: 1,
      pageSize: 2000,
    },
   
  );
  return response.data;
}

async function fetchDeviceShadow(deviceId) {
  const response = await axios.post(
   `${BASE_URL}api/deviceShadow`,
    { deviceId },

  );
  return response.data;
}

async function fetchDevicePoi({ lat, lon }) {
  const response = await axios.post(
    `${BASE_URL}api/poi`,
    { lat, lon },
   
  );
  return response.data;
}


export {fetchDevicePoi,fetchDeviceShadow,fetchMonitorAbbrev};
